import React, {Component} from 'react'
import {connect} from 'react-redux'
import LoginActions from '../reducers/login/LoginRedux'
import {Redirect} from 'react-router-dom'
import '../assets/App.css'
import {
    Row,
    Col,
    Icon,
    Grid,
    Form,
    Panel,
    Button,
    Navbar,
    PanelBody,
    FormGroup,
    InputGroup,
    FormControl,
    PanelContainer,
    HelpBlock
} from '@sketchpixy/rubix'
import {ERROR_MESSAGES, FIELD_STATUSES} from '../utils'
import NotificationSystem from 'react-notification-system'
import LoadingContainer from "../components/LoadingContainer";
import packageJson from "../../package.json"

class LoginPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            authenticate: !!this.props.loginToken,
            emailError: {
                status: null,
                message: ''
            },
            passwordError: {
                status: null,
                message: ''
            },
            loginError: ''
        }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            autoDismiss: 2
        })

        if (type === 'error') {
            this.setState({
                emailError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                passwordError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                }
            })
        }
    }

    componentWillReceiveProps(newProps) {
        const {fetching, error, forgotPasswordMessage} = newProps
        if (newProps.loginToken) {
            this.setState({authenticate: true})
        }
        if (!fetching && !error && forgotPasswordMessage) {
            this._addNotification(forgotPasswordMessage, 'success', 'Success Message: ',)
        } else if (!fetching && error) {
            this._addNotification(error, 'error', 'Error Message: ',)
        }

    }

    handleInputChange = ({target: {name, value}}) => {
        this.setState({
            [name]: value,
            emailError: {
                status: null,
                message: ''
            },
            passwordError: {
                status: null,
                message: ''
            }
        })
    }

    handleFieldValidations = () => {
        const {email, password} = this.state
        let [emailError, passwordError, errorExist] = [{}, {}, false]
        if (!email) {
            emailError.status = FIELD_STATUSES.ERROR
            emailError.message = ERROR_MESSAGES.USER_ERROR_MESSAGE
            errorExist = true
        }

        if (!password) {
            passwordError.status = FIELD_STATUSES.ERROR
            passwordError.message = ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE
            errorExist = true
        }

        return {emailError, passwordError, errorExist}
    }

    pressLogin = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const {emailError, passwordError, errorExist} = this.handleFieldValidations()
        if (errorExist) {
            this.setState({
                emailError,
                passwordError
            })
        }
        const {email, password} = this.state
        if (email && password && password.length>4) {
            this.props.loginRequest(email, password)
        } else {
            this._addNotification("Password length is minimum 5 characters", 'error', 'Error Message: ',)
        }
    }

    forgotPassword = (e) => {

        const {history} = this.props

        history.push('/reset-password');
        // e.preventDefault()
        // e.stopPropagation()
        // const {emailError, errorExist} = this.handleFieldValidations()
        // if (errorExist) {
        //     this.setState({
        //         emailError
        //     })
        // }
        // const {email} = this.state
        // if (email) {
        //     this.props.forgotPasswordRequest(email)
        // }
    }

    // logoutUser = (e) => {
    //     if (this.props.loginToken) {
    //         this.props.logoutUser()
    //     } else {
    //         this.props.history.push('/')
    //     }
    // }

    render() {
        const {fetching, error} = this.props;
        const {
            authenticate, email, password, emailError: {status: emailStatus, message: emailError},
            passwordError: {status: passwordStatus, message: passwordError}
        } = this.state
        let {from} = this.props.location.state || {from: '/confirm'}

        if (authenticate) {
            return (
                <Redirect to={from}/>
            )
        }

        return (
          <div style={{overflow: "scroll"}}>
            <div
              style={{
                paddingLeft: "35px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <a href="/">
                <img
                  style={{ margin: "0" }}
                  src="/imgs/app/vbgTextIcon.svg"
                  width="180"
                  alt=""
                  height="70"
                />
              </a>
            </div>
            <div
              style={{
                backgroundColor: "rgb(247, 247, 247)",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="auth-page-style" style={{ margin: "0 auto" }}>
                <div className="text-center fg-darkblue">
                  <h1 className="heading-main">Let's Get Started</h1>
                </div>

                <div
                  style={{
                    padding: 25,
                  }}
                >
                  <Form>
                    <FormGroup
                      controlId="emailAddress"
                      validationState={emailStatus}
                    >
                      <InputGroup bsSize="large">
                        <InputGroup.Addon></InputGroup.Addon>
                        <label className="form-label">Enter your email </label>
                        <FormControl
                          autoFocus
                          type="email"
                          className="border-focus-blue required border-blue input1"
                          name="email"
                          onChange={this.handleInputChange}
                          value={email}
                        />
                      </InputGroup>
                      <HelpBlock>{emailError}</HelpBlock>
                    </FormGroup>
                    <FormGroup
                      controlId="password"
                      validationState={passwordStatus}
                    >
                      <InputGroup bsSize="large">
                        <InputGroup.Addon></InputGroup.Addon>
                        <label className="form-label">
                          Enter your password
                        </label>
                        <FormControl
                          type="password"
                          className="border-focus-blue border-blue"
                          name="password"
                          onChange={this.handleInputChange}
                          value={password}
                        />
                      </InputGroup>
                      <HelpBlock>{passwordError}</HelpBlock>
                    </FormGroup>
                    <NotificationSystem ref="notificationSystem" />
                    <FormGroup>
                      <Grid>
                        <Row style={{ marginBottom: 15 }}>
                          <Col md={12} collapseLeft collapseRight>
                            <Button
                              className="no-outline forget-pass"
                              lg
                              type="button"
                              bsStyle="link"
                              onClick={this.forgotPassword}
                            >
                              Forgot Your Password?
                            </Button>
                          </Col>
                          <Col
                            md={12}
                            collapseLeft
                            collapseRight
                            className="text-right"
                          >
                            <Button
                              lg
                              type="submit"
                              bsStyle="primary"
                              className="bg-darkblue full-button"
                              onClick={this.pressLogin}
                            >
                              Sign In
                              <Icon
                                className="icon-right"
                                glyph="glyphicon-menu-right"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Grid>
                    </FormGroup>
                  </Form>
                </div>
                {fetching && !error && <LoadingContainer />}
              </div>
            </div>
            <span style={{display: "block", textAlign: "center", bottom: 0, width: "100%", marginTop: "20px"}}>
              &copy; 2024 Veteran Benefits Guide
              <br />
              App version: {packageJson.version}
              <br />
            </span>
          </div>
        );
    }
}

const
    mapStateToProps = ({login}) => {
        const {loginToken, error, fetching, role, forgotPasswordMessage} = login
        return {loginToken, error, fetching, role, forgotPasswordMessage}
    }

const
    mapDispatchToProps = dispatch => ({
        loginRequest: (email, password) => {
            dispatch(LoginActions.createLoginRequest(email, password))
        },
        forgotPasswordRequest: (email) => {
            dispatch(LoginActions.createForgotRequest(email))
        },
        logoutUser: () => {
            dispatch(LoginActions.createLogoutSuccess())
        }
    })

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
